export const RECEIVE_LAST_MODIFIED_DATE = "RECEIVE_LAST_MODIFIED_DATE"
export const DOWNLOAD_ALL_CONSTITUENTS = "DOWNLOAD_ALL_CONSTITUENTS"
export const GET_CONSTITUENT_OPTIONS = "GET_CONSTITUENT_OPTIONS"
export const RECEIVE_CONSTITUENT_OPTIONS = "RECEIVE_CONSTITUENT_OPTIONS"
export const UPDATE_CONSTITUENT_OPTIONS = "UPDATE_CONSTITUENT_OPTIONS"
export const GET_DATA_ENRICHMENT_REQUEST = "GET_DATA_ENRICHMENT_REQUEST"
export const POST_DATA_ENRICHMENT_REQUEST = "POST_DATA_ENRICHMENT_REQUEST"
export const RECEIVE_DATA_ENRICHMENT_REQUEST = "RECEIVE_DATA_ENRICHMENT_REQUEST"
export const GET_DATA_HEALTH_STATS = "GET_DATA_HEALTH_STATS"
export const RECEIVE_DATA_HEALTH_STATS = "RECEIVE_DATA_HEALTH_STATS"
export const REQUEUE_NOT_SURE = "REQUEUE_NOT_SURE"
export const DOWNLOAD_DATA = "DOWNLOAD_DATA"
export const UPDATE_DATA_HEALTH_AMOUNT = "UPDATE_DATA_HEALTH_AMOUNT"
export const RECEIVE_FIND_EMAIL_STATS = "RECEIVE_FIND_EMAIL_STATS"
export const GET_FIND_EMAIL_STATS = "GET_FIND_EMAIL_STATS"
export const SEND_CONFIRMATION_EMAILS = "SEND_CONFIRMATION_EMAILS"

export const receiveFindEmailStats = (stats) => ({
  type: RECEIVE_FIND_EMAIL_STATS,
  stats,
})

export const sendConfirmationEmails = (success, error) => ({
  type: SEND_CONFIRMATION_EMAILS,
  success,
  error,
})

export const getFindEmailStats = (success, error) => ({
  type: GET_FIND_EMAIL_STATS,
  success,
  error,
})

export const downloadData = (params, success, error) => ({
  type: DOWNLOAD_DATA,
  params,
  success,
  error,
})

export const receiveDataHealthStats = (stats) => ({
  type: RECEIVE_DATA_HEALTH_STATS,
  stats,
})

export const requeueNotSure = (success, error) => ({
  type: REQUEUE_NOT_SURE,
  success,
  error,
})

export const getDataHealthStats = (success, error) => ({
  type: GET_DATA_HEALTH_STATS,
  success,
  error,
})

export const getDataEnrichmentRequest = (success, error) => ({
  type: GET_DATA_ENRICHMENT_REQUEST,
  success,
  error,
})

export const updateDataHealthAmount = (field, amount) => ({
  type: UPDATE_DATA_HEALTH_AMOUNT,
  field,
  amount,
})

export const postDataEnrichmentRequest = (success, error) => ({
  type: POST_DATA_ENRICHMENT_REQUEST,
  success,
  error,
})

export const receiveDataEnrichmentRequest = (resp) => ({
  type: RECEIVE_DATA_ENRICHMENT_REQUEST,
  resp,
})

export const downloadAllConstituents = (success, error) => ({
  type: DOWNLOAD_ALL_CONSTITUENTS,
  success,
  error,
})

export const receiveLastModifiedDate = (lastModifiedDate) => ({
  type: RECEIVE_LAST_MODIFIED_DATE,
  lastModifiedDate,
})

export const getConstituentOptions = (query, success, error) => ({
  type: GET_CONSTITUENT_OPTIONS,
  query,
  success,
  error,
})

export const receiveConstituentOptions = (resp) => ({
  type: RECEIVE_CONSTITUENT_OPTIONS,
  resp,
})

export const updateConstituentOptions = (params, success, error) => ({
  type: UPDATE_CONSTITUENT_OPTIONS,
  params,
  success,
  error,
})
